import { Action, combineReducers } from "redux";
import * as store from "../../../framework/customStore";
import { TDefaultListFilter } from "../../common/defaultListFilter";
import { IRecordPage } from "../../record/recordPage";
import { TDefaultReportFilter } from "../../common/defaultReportFilter";

// State
export interface IRecordPageState {
    dataId: number;
    recordPage: IRecordPage;
}

export interface IRecordListState {
    defaultFilter: TDefaultListFilter;
}

export interface IRecordReportState {
    defaultFilter: TDefaultReportFilter;
}

export interface IRecordState {
    page: IRecordPageState;
    list: IRecordListState;
    report: IRecordReportState;
}

// Action type constants
const RECORD_SUCCESS = "RECORD_SUCCESS";
const RECORD_FAILURE = "RECORD_FAILURE";

const RECORD_SUCCESS_LIST_SET_DEFAULT_FILTER = "RECORD_SUCCESS_LIST_SET_DEFAULT_FILTER";

const RECORD_SUCCESS_REPORT_SET_DEFAULT_FILTER = "RECORD_SUCCESS_REPORT_SET_DEFAULT_FILTER";

type T_RECORD_SUCCESS = typeof RECORD_SUCCESS;
type T_RECORD_FAILURE = typeof RECORD_FAILURE;

type T_RECORD_SUCCESS_LIST_SET_DEFAULT_FILTER = typeof RECORD_SUCCESS_LIST_SET_DEFAULT_FILTER;

type T_RECORD_SUCCESS_REPORT_SET_DEFAULT_FILTER = typeof RECORD_SUCCESS_REPORT_SET_DEFAULT_FILTER;

// Action types

// Records
interface IRecordSuccess extends Action {
    type: T_RECORD_SUCCESS;
    recordPage: IRecordPage;
}

interface IRecordFailure extends Action {
    type: T_RECORD_FAILURE;
}

interface IRecordListSetDefaultFilter extends Action {
    type: T_RECORD_SUCCESS_LIST_SET_DEFAULT_FILTER;
    defaultFilter: TDefaultListFilter;
}

interface IRecordReportSetDefaultFilter extends Action {
    type: T_RECORD_SUCCESS_REPORT_SET_DEFAULT_FILTER;
    defaultFilter: TDefaultReportFilter;
}

export type RecordsAction =
    | IRecordSuccess
    | IRecordFailure
    | IRecordListSetDefaultFilter
    | IRecordReportSetDefaultFilter;

//Actions
export const recordSuccess = (recordPage: IRecordPage): IRecordSuccess => ({
    type: RECORD_SUCCESS,
    recordPage
});

export const recordFailure = (): IRecordFailure => ({
    type: RECORD_FAILURE
});

export const recordListSetDefaultFilter = (defaultFilter: TDefaultListFilter): IRecordListSetDefaultFilter => ({
    type: RECORD_SUCCESS_LIST_SET_DEFAULT_FILTER,
    defaultFilter
});

export const recordReportSetDefaultFilter = (defaultFilter: TDefaultReportFilter): IRecordReportSetDefaultFilter => ({
    type: RECORD_SUCCESS_REPORT_SET_DEFAULT_FILTER,
    defaultFilter
});

//Reducers
export const recordInitialState: IRecordState = {
    page: {
        dataId: 0,
        recordPage: null
    },
    list: {
        defaultFilter: null
    },
    report: {
        defaultFilter: null
    }
};

const page = (state: IRecordPageState = null, action: RecordsAction) => {
    switch (action.type) {
    case RECORD_SUCCESS: {
        const recordsSuccess = action as IRecordSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            recordPage: recordsSuccess.recordPage
        };
    }
    case RECORD_FAILURE:
        return { ...state };
    }
    return state;
};

const list = (state: IRecordListState = null, action: RecordsAction) => {
    switch (action.type) {
    case RECORD_SUCCESS_LIST_SET_DEFAULT_FILTER: {
        const listDefaultFilter = action as IRecordListSetDefaultFilter;
        return {
            ...state,
            defaultFilter: listDefaultFilter.defaultFilter
        };
    }
    }
    return state;
};

const report = (state: IRecordReportState = null, action: RecordsAction) => {
    switch (action.type) {
    case RECORD_SUCCESS_REPORT_SET_DEFAULT_FILTER: {
        const listDefaultFilter = action as IRecordReportSetDefaultFilter;
        return {
            ...state,
            defaultFilter: listDefaultFilter.defaultFilter
        };
    }
    }
    return state;
};

//Root reducer
export const recordReducer = combineReducers({
    page,
    list,
    report
});

//Utils
export const setRecordListDefaultFilter = (defaultFilter: TDefaultListFilter) => {
    store.customStore.dispatch(recordListSetDefaultFilter(defaultFilter));
};

export const setRecordReportDefaultFilter = (defaultFilter: TDefaultReportFilter) => {
    store.customStore.dispatch(recordReportSetDefaultFilter(defaultFilter));
};